import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'

import { TestExecution } from '../../models/'
import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../../model-repository/model-repository'

@Injectable()
export class TestExecutionService extends ModelRepositoryAdapter<TestExecution> {
  constructor(
    private _modelRepository: ModelRepository
  ) {
    super(_modelRepository, TestExecution)
  }

  public findLatestByTestIds(
    testIds: string[],
    extraCriteria: {[key: string]: any} = {},
    includes?
  ): Observable<TestExecution[]> {
    includes = includes || ['testExecutionResults', 'test']
    return this.findModelsBy(
      Object.assign({}, extraCriteria, {test: testIds, recency: 'latest'}),
      includes
    ) as Observable<TestExecution[]>
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/test-execution/test-execution.service.ts